import store from "../store";
import { getFirstAllowedPage } from "../utils/permissionHelpers";

export default [
  {
    path: "*",
    meta: {
      public: true,
    },
    redirect: {
      path: "/404",
    },
  },
  {
    path: "/404",
    meta: {
      public: true,
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      ),
  },
  

  {
    path: "/login",
    meta: {
      public: true,
    },
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      ),
    beforeEnter(to, from, next) {
      if (store.state.user) {
        const firstPage = getFirstAllowedPage();
        next(firstPage);
      } else {
        next();
      }
    },
  },
  {
    path: "/reset-password",
    meta: {  public: true,breadcrumb: true, title: "Reset Password" },
    name: "Reset Password",
    component: () => import("@/views/ResetPassword"),
  },
  {
    path: "/reset-password-email",
    meta: { public: true, breadcrumb: true, title: "Reset Password" },
    name: "Reset Password",
    component: () => import("@/views/ResetPasswordEmail"),
  },
  {
    path: "",
    meta: { breadcrumb: true },
    name: "Root",
    async beforeEnter(to, from, next) {
      await store.dispatch("validateToken");
      if (!store.state.user) next(`login?next=${to.name}`);
      else {
        next();
      }
    },
    component: () => import("@/components/RootComponent"),
    redirect: { name: "Home" },
    children: [
      
      {
        path: "/home",
        meta: { breadcrumb: true, title: "Home" },
        name: "Home",
        component: () => import("@/views/TransferCenter/Home"),
      },
       {
        path: "/drivers-transfers",
        meta: { breadcrumb: true, title: "Drivers Transfers" },
        name: "DriversTransfers",
        component: () => import("@/views/TransferCenter/DriversTransfers"),
      },
       {
        // Client decision 2026-09-08: a center transfers to everything in the
        // app, not only drivers.
        path: "/riders-transfers",
        meta: { breadcrumb: true, title: "Riders Transfers" },
        name: "PassengersTransfers",
        component: () => import("@/views/TransferCenter/PassengersTransfers"),
      },
      {
        path: "/business-transfers",
        meta: { breadcrumb: true, title: "Business Transfers" },
        name: "BusinessTransfers",
        component: () => import("@/views/TransferCenter/BusinessTransfers"),
      },
      {
        path: "/admin-transfers",
        meta: { breadcrumb: true, title: "Admin Transfers" },
        name: "AdminTransfers",
        component: () => import("@/views/TransferCenter/AdminTransfers"),
      }
      
      
    ],
  },
];
